// https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/

import React from 'react'
import { viewportContext } from './viewport-context';

const useViewport = () => {
  const { width, height } = React.useContext(viewportContext);
  return { width, height };
}

export { useViewport }